import AxiosService from "plugins/TS-lib-utils-public/services/AxiosService"; 

class UsersDoctorService extends AxiosService {
    constructor() {
        super("aspect-doctor-user");
    }

    updateExtRef = async (data) => {
        return await this.put(`/doctors/${data.auth_user_id}/ext_ref`, data, {
            headers: {
                Authorization: `Bearer ${this.getToken()}`,
            },
        });
    }

}

export default new UsersDoctorService();
